// extracted by mini-css-extract-plugin
export default {"r_l":"abc23d8ad8 e2d0c6283c","t":"c0ba222c7e"};